import adserver from 'services/adserver';
import { BasketParams } from './baskets.types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { basketsKeys } from './baskets.keys';

const getCommittedBasket = async (basketId: number) => {
  const { data } = await adserver({
    url: `/basket/${basketId}/committed`,
    headers: {},
  });
  return data;
};

export const useGetCommittedBasket = <TData = BasketParams>(
  basketId: number,
  enabled = true,
  select?: (data: BasketParams) => TData,
): UseQueryResult<TData, unknown> =>
  useQuery({
    queryKey: basketsKeys.committed(basketId),
    queryFn: () => getCommittedBasket(basketId),
    enabled: !!basketId && enabled,
    select,
  });
